export enum RequestType {
  REFUND_DEPOSIT = 'REFUND_DEPOSIT',
}

export enum RequestStatus {
  SUBMITTED = 'SUBMITTED',
  RESUBMITTED = 'RESUBMITTED',
  REJECTED = 'REJECTED',
  APPROVED = 'APPROVED',
  COMPLETED = 'COMPLETED',
  ABANDONED = 'ABANDONED',
}

export enum RequestTag {
  BATCH_CLAIM_PAYMENT = 'BATCH_CLAIM_PAYMENT',
}

export const pendingRequestStatus = new Set([
  RequestStatus.SUBMITTED,
  RequestStatus.RESUBMITTED,
  RequestStatus.REJECTED,
]);
